<template>
  <div>
    <div class="coupon-list-window" :class="value === true ? 'on' : ''">
      <div class="title">
        优惠码
        <span class="iconfont icon-guanbi" @click="close"></span>
      </div>
      <div style="padding:10px 20px 20px 20px">
          <input style="width:100%;border:1.5px red solid;height:35px; line-height:35px; font-size:18px;padding:0px 5px;" placeholder="输入优惠码" v-model="couponcode" />
      </div>
      <div style="width:100%;margin-bottom:30px;">
            <div class="confirmbtn" @click="click">确定使用</div>
      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      :hidden="value === false"
      @click="close"
    ></div>
  </div>
</template>
<style scoped>
.coupon-list-window .iconfont {
  font-size: 0.4rem;
}
.confirmbtn{
    margin: auto;
    font-size: 0.3rem;
    color: #fff;
    width: 2.4rem;
    height: 0.7rem;
    background-color: #e93323;
    border-radius: 0.5rem;
    text-align: center;
    line-height: 0.7rem;
}
.couponNo {
  font-size: 0.3rem;
  font-weight: bold;
  color: #fff;
  width: 6.9rem;
  height: 0.86rem;
  border-radius: 0.43rem;
  text-align: center;
  line-height: 0.86rem;
  margin: 0.6rem auto;
}
</style>
<script>

export default {
  name: "CouponCodeWindow",
  props: {
    value: Boolean,
    checked: Number,
    price: {
      type: [Number, String],
      default: undefined
    }
  },
  data: function() {
    return {
      loaded: false,
      couponcode: ''
    };
  },
  watch: {
    price(n) {
      if (n === undefined || n == null) return;
      this.checkCouponCode();
    }
  },
  mounted: function() {},
  methods: {
    close: function() {
      this.couponcode='';
      this.$emit("input", false);
      this.$emit("checked", this.couponcode);
    //   this.$emit("close");
    },
    checkCouponCode() {
        console.log(111)
    //   this.loaded = true;
    },
    click() {
      this.$emit("checked", this.couponcode);
      this.$emit("input", false);
      this.couponcode='';
    }
  }
};
</script>
